import apiService from 'src/enviroment';

// eslint-disable-next-line import/prefer-default-export
const bussinesUnits = {
  getUnidades: () => apiService.get('/segmentacion/unidadesnegocio/'),
  getUnitsUser: (body) => apiService.get(`/admin/unidadesusuario/?usuario_id=${body}`),
};

export default bussinesUnits;
